import { Helmet } from 'react-helmet-async';
import BoardView from './components/BoardView';

export default function MyTaskBoardPage() {
  return (
    <>
      <Helmet>
        <title> My Task </title>
      </Helmet>
      <BoardView />
    </>
  );
}
